import { SimpleATHandler, SimpleAVHandler, SimpleTHandler } from 'src/app/types/@types/sl-v-types';
import { SLProject } from 'src/app/model/sl-project';

import { Injectable } from '@angular/core';
import { SlWapiService } from './sl-wapi.service';
import { CancellablePromise } from 'src/app/types/cancellable-promise';

@Injectable({
	providedIn: 'root'
})
export class MediaService {

	constructor(private wapi: SlWapiService ) {
	}

	GetFeatureImage(imgURL: string): CancellablePromise {
		let url = 'media/featureImage/';
		const imageURLParts: Array<string> = imgURL.split('/');
		imageURLParts.shift();
		imageURLParts.shift();
		url += imageURLParts.join('/');
		url += '/';
		return this.wapi.Post('media/featureImage/' + url, { encode: 'media-url' });
	}

  GetOrgMedia(project:SLProject,handler:SimpleAVHandler<string> ,what:'logo' = 'logo',) {
    let url = `organization/media/get:${what}/`;
    this.wapi.Post(url,{encode:'media-url',as:project.owner}).then((reply)=>{
      handler(reply?.response?.media as string);
    });
  }

}
